var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [_vm._m(0), _vm._v(" "), _c("app-backend-footer")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid xyz" }, [
      _c("div", { staticClass: "page-header-top-container" }, [
        _c("div", { staticClass: "page-name" }, [_vm._v("Carousel")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "admin-page-content" }, [
        _c("div", { staticClass: "carousel-container" }, [
          _c("div", { staticClass: "row no-margin" }, [
            _c("div", { staticClass: "col-6 paddingleft0" }, [
              _c(
                "div",
                { staticClass: "carousel-block without-bottom-navigation" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "carousel slide",
                      attrs: { id: "carousel1", "data-ride": "carousel" }
                    },
                    [
                      _c("ul", { staticClass: "carousel-indicators" }, [
                        _c("li", {
                          staticClass: "active",
                          attrs: {
                            "data-target": "#carousel1",
                            "data-slide-to": "0"
                          }
                        }),
                        _vm._v(" "),
                        _c("li", {
                          attrs: {
                            "data-target": "#carousel1",
                            "data-slide-to": "1"
                          }
                        }),
                        _vm._v(" "),
                        _c("li", {
                          attrs: {
                            "data-target": "#carousel1",
                            "data-slide-to": "2"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "carousel-inner" }, [
                        _c("div", { staticClass: "carousel-item active" }, [
                          _c("img", {
                            attrs: { src: "/static/images/carousal_img.jpg" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "carousel-item" }, [
                          _c("img", {
                            attrs: { src: "/static/images/carousal_img.jpg" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "carousel-item" }, [
                          _c("img", {
                            attrs: { src: "/static/images/carousal_img.jpg" }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-prev",
                          attrs: { href: "#carousel1", "data-slide": "prev" }
                        },
                        [
                          _c("span", {
                            staticClass: "carousel-control-prev-icon"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-next",
                          attrs: { href: "#carousel1", "data-slide": "next" }
                        },
                        [
                          _c("span", {
                            staticClass: "carousel-control-next-icon"
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 paddingright0" }, [
              _c(
                "div",
                { staticClass: "carousel-block without-middle-navigation" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "carousel slide",
                      attrs: { id: "carousel2", "data-ride": "carousel" }
                    },
                    [
                      _c("ul", { staticClass: "carousel-indicators" }, [
                        _c("li", {
                          staticClass: "active",
                          attrs: {
                            "data-target": "#carousel2",
                            "data-slide-to": "0"
                          }
                        }),
                        _vm._v(" "),
                        _c("li", {
                          attrs: {
                            "data-target": "#carousel2",
                            "data-slide-to": "1"
                          }
                        }),
                        _vm._v(" "),
                        _c("li", {
                          attrs: {
                            "data-target": "#carousel2",
                            "data-slide-to": "2"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "carousel-inner" }, [
                        _c("div", { staticClass: "carousel-item active" }, [
                          _c("img", {
                            attrs: { src: "/static/images/carousal_img.jpg" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "carousel-caption" }, [
                            _c("h3", [_vm._v("Title goes here")]),
                            _vm._v(" "),
                            _c("p", [_vm._v("We had such a great time in LA!")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "carousel-item" }, [
                          _c("img", {
                            attrs: { src: "/static/images/carousal_img.jpg" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "carousel-caption" }, [
                            _c("h3", [_vm._v("Title goes here")]),
                            _vm._v(" "),
                            _c("p", [_vm._v("We had such a great time in LA!")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "carousel-item" }, [
                          _c("img", {
                            attrs: { src: "/static/images/carousal_img.jpg" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "carousel-caption" }, [
                            _c("h3", [_vm._v("Title goes here")]),
                            _vm._v(" "),
                            _c("p", [_vm._v("We had such a great time in LA!")])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-prev",
                          attrs: { href: "#carousel2", "data-slide": "prev" }
                        },
                        [
                          _c("span", {
                            staticClass: "carousel-control-prev-icon"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-next",
                          attrs: { href: "#carousel2", "data-slide": "next" }
                        },
                        [
                          _c("span", {
                            staticClass: "carousel-control-next-icon"
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "height30" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 paddingleft0" }, [
              _c(
                "div",
                { staticClass: "carousel-block without-middle-navigation" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "carousel slide",
                      attrs: { id: "carousel3", "data-ride": "carousel" }
                    },
                    [
                      _c("ul", { staticClass: "carousel-indicators" }, [
                        _c("li", {
                          staticClass: "active",
                          attrs: {
                            "data-target": "#carousel3",
                            "data-slide-to": "0"
                          }
                        }),
                        _vm._v(" "),
                        _c("li", {
                          attrs: {
                            "data-target": "#carousel3",
                            "data-slide-to": "1"
                          }
                        }),
                        _vm._v(" "),
                        _c("li", {
                          attrs: {
                            "data-target": "#carousel3",
                            "data-slide-to": "2"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "carousel-inner" }, [
                        _c("div", { staticClass: "carousel-item active" }, [
                          _c("img", {
                            attrs: { src: "/static/images/carousal_img.jpg" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "carousel-item" }, [
                          _c("img", {
                            attrs: { src: "/static/images/carousal_img.jpg" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "carousel-item" }, [
                          _c("img", {
                            attrs: { src: "/static/images/carousal_img.jpg" }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-prev",
                          attrs: { href: "#carousel3", "data-slide": "prev" }
                        },
                        [
                          _c("span", {
                            staticClass: "carousel-control-prev-icon"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-next",
                          attrs: { href: "#carousel3", "data-slide": "next" }
                        },
                        [
                          _c("span", {
                            staticClass: "carousel-control-next-icon"
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7db61af4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db61af4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousal.vue
// module id = null
// module chunks = 